export default function comparisonTable($table) {
    if (!$table || $table.nodeName.toLowerCase() !== 'table') {
        throw new Error('comparisonTable requires a table element as a parameter.');
    }

    const HIDE_CLASS = 'jsHide';

    const getProductIds = () => [...$table.querySelectorAll(`thead > tr > th[data-column]:not(.${HIDE_CLASS})`)].map($column => $column.dataset.column);

    const columnCount = () => getProductIds().length;

    const updateColSpan = count => {
        $table.dataset.columns = count;

        [...$table.querySelectorAll('[colspan]')].forEach($element => $element.setAttribute('colspan', count));
    };

    const hideById = id => {
        [...$table.querySelectorAll(`[data-column="${id}"]`)]
            .forEach($element => $element.classList.add(HIDE_CLASS));
    };

    const showAll = () => {
        [...$table.querySelectorAll(`th.${HIDE_CLASS}, td.${HIDE_CLASS}`)]
            .forEach($element => $element.classList.remove(HIDE_CLASS));
    };

    const initialIds = getProductIds();

    return {
        getProductIds,
        removeById: id => {
            [...$table.querySelectorAll(`[data-column="${id}"]`)]
                .forEach($cell => $cell.remove());

            updateColSpan(columnCount());
        },
        showIds: ids => {
            showAll();

            initialIds
                .filter(id => !ids.includes(id))
                .forEach(id => hideById(id));

            updateColSpan(columnCount());
        }
    };
}